import { ReactElement } from 'react';
import ApplicationReasons from '@components/FVSPage/ApplicationReasons';
import { fvsInfoDisplayObject } from '@services/FormFieldConfig';

function FVSStep22(): ReactElement {
  return (
    <>
      <ApplicationReasons displayObject={fvsInfoDisplayObject} currentStepNo="step22" />
    </>
  );
}

export default FVSStep22;
